/**
 * TagManager Constants - Centralized string literals for the TagManager component
 */

export const TAG_MANAGER_STRINGS = {
  LOADING_TAGS: 'Loading tags...' as const,
  SAVING_TAGS: 'Updating your tags...' as const,

  DRAWER_TITLE: 'Manage Tags' as const,

  CANCEL: 'Cancel' as const,
  CREATE_NEW_TAG: 'Create a New Tag' as const,
  SAVE: 'Save' as const,
  SAVING: 'Saving...' as const,

  SELECT_TAG_COLOR: 'Select tag color' as const,
  DELETE_TAG: 'Delete tag' as const,
  SELECT_COLOR: 'Select {colorName} color' as const,

  // Delete confirmation modal
  DELETE_TAG_TITLE: 'Delete tag?' as const,
  DELETE_TAG_DESCRIPTION: 'Are you sure you want to delete this tag? This action will delete the tag across all of Financials and cannot be undone.' as const,
  DELETE_TAG_BUTTON: 'Delete' as const,
  DELETE_TAG_CANCEL: 'Cancel' as const,

  TAGS_FIELD: 'tags' as const,

  TEST_ID_COLOR_PICKER: 'tag-color-picker' as const,
  TEST_ID_COLOR_OPTION_PREFIX: 'tag-color-picker-option-' as const,

  ARROW_RIGHT: 'ArrowRight' as const,
  ARROW_LEFT: 'ArrowLeft' as const,
  ARROW_DOWN: 'ArrowDown' as const,
  ARROW_UP: 'ArrowUp' as const,
  ENTER: 'Enter' as const,
  SPACE: ' ' as const,

  SOURCE_CREATE: 'create' as const,
  SOURCE_EDIT: 'edit' as const
} as const;

export const formatString = (
  template: string,
  replacements: Record<string, string>
): string => {
  return template.replace(
    /{(\w+)}/g,
    (match, key) => replacements[key] || match
  );
};
